import {useSessionstorageState} from 'rooks';
import {PRIVATE_KEY_STORAGE_ID} from '../config/misc';

const usePrivateKeyState = () => {
  return useSessionstorageState(PRIVATE_KEY_STORAGE_ID, '');
};

export default usePrivateKeyState;
